import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MAIN_URL } from 'src/app/constant/app-constant';

@Injectable()
export class TimelineService {

  constructor(private http: HttpClient) { }
  // getAllNews(): Observable<any> {
  //   return this.http.get<any>(MAIN_URL + "post/allpost");
  // }

  // getFeaturedNews(catg_id: number, page: number, limit: number): Observable<any> {
  //   return this.http.get<any>(MAIN_URL + "post/categoryPostPagination/" + catg_id + "/" + page + "/" + limit + "/");
  // }

  getTimelineNewsByDate(year: number, month: number, date: number, page: number, limit: number): Observable<any> {
    console.log(year," - ",month," - ",date);

    return this.http.get<any>(MAIN_URL + "post/TimelinePostPaginationByDate/" + year + "/"+ month + "/"+ date + "/" + page + "/" + limit + "");
  }

  getTimelineNewsByMonth(year: number, month: number, page: number, limit: number): Observable<any> {
    return this.http.get<any>(MAIN_URL + "post/TimelinePostPaginationByMonth/" + year + "/"+ month + "/" + page + "/" + limit + "");
  }

  getTimelineNewsByYear(year: number, page: number, limit: number): Observable<any> {
    return this.http.get<any>(MAIN_URL + "post/TimelinePostPaginationByYear/" + year + "/" + page + "/" + limit + "");
  }

  getPostByPaginationByDate(year: number, month: number, date: number, page: number, limit: number): Observable<any> {
    return this.http.get<any>(MAIN_URL + "post/TimelinePostPaginationByDate/" + year + "/"+ month + "/"+ date + "/" + page + "/" + limit + "/");
  }

  getPostByPaginationByMonth(year: number, month: number, page: number, limit: number): Observable<any> {
    return this.http.get<any>(MAIN_URL + "post/TimelinePostPaginationByMonth/" + year + "/"+ month + "/" + page + "/" + limit + "/");
  }

  getPostByPaginationByYear(year: number, page: number, limit: number): Observable<any> {
    return this.http.get<any>(MAIN_URL + "post/TimelinePostPaginationByYear/" + year + "/" + page + "/" + limit + "/");
  }
}